import { render, staticRenderFns } from "./LayoutColumn.vue?vue&type=template&id=c437308c&scoped=true&"
import script from "./LayoutColumn.vue?vue&type=script&lang=js&"
export * from "./LayoutColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c437308c",
  null
  
)

export default component.exports